import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import EditButton from "react-mui-lib/grid-widgets/EditButton";
import Grid from 'react-mui-lib/grid-widgets/Grid';
import Search from 'react-mui-lib/grid-widgets/filters/Search';
import registry from 'react-mui-lib/registry';
import { format_timestamp } from '../utils';


class ConfirmDeleteDialog extends React.Component {
    constructor(props) {
        super(props);

        this.controller = registry.get('franchise_list_controller');

        this.state = {
            open: false,
            item_id: null
        };
    }

    open(item_id) {
        this.setState({
            open: true,
            item_id
        });
    }

    onDelete = () => {
        this.controller.deleteById(this.state.item_id);
        this.onClose();
    };

    onClose = () => {
        this.setState({open: false});
    };

    render() {
        const c = this;

        return <Dialog open={c.state.open}
                       onClose={c.onClose}>
            <DialogTitle>
                {`Удалить автора ${c.state.item_id}?`}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={c.onClose} color="primary">
                    Отмена
                </Button>
                <Button onClick={c.onDelete}
                        color="secondary"
                        variant="raised"
                        autoFocus>
                    Удалить
                </Button>
            </DialogActions>
        </Dialog>;
    }
}


class FranchiseGrid extends React.Component {
    deleteItem(item_id) {
        this.refs.dialog.open(item_id);
    }

    constructor(props) {
        super(props);

        this.controller = registry.get('franchise_list_controller');

        this.columns = [{
            key: 'id',
            template: ({val, row}) =>
                <div style={{whiteSpace: 'nowrap'}}>
                    <IconButton onClick={() => this.deleteItem(val)}>
                        <Icon>delete</Icon>
                    </IconButton>
                    <EditButton to={`/admin/franchise/${val}`} />
                    {row.name || val}
                </div>
        }, {
            key: 'organizer_name',
            label: 'Никнейм'
        }, {
            key: 'organizer_phone',
            label: 'Телефон'
        }, {
            key: 'games',
            label: 'Игры',
            sortable: false,
            template: ({val}) =>
                <span>{val}</span>
        }, {
            key: 'locality.region.name',
            label: 'Регион'
        }, {
            key: 'locality.name',
            label: 'Нас. пункт'
        }, {
            key: 'last_admin_visit',
            label: 'Посл. визит',
            template: ({val}) =>
                <span>{val ? format_timestamp(val) : '—'}</span>
        }];
    }

    render() {
        const c = this;

        return <Grid controller={c.controller}
                     columns={c.columns}
                     title="Авторы">
            <Search controller={c.controller}/>
            <ConfirmDeleteDialog ref="dialog" />
        </Grid>;
    }

    componentWillMount() {
        const c = this;
        c.controller.loadIfNeeded();
    }
}

export default FranchiseGrid;
